// extracted by mini-css-extract-plugin
module.exports = {"listTitle":"EditRecommend_listTitle__3mEog","list":"EditRecommend_list__1dg_B","updateButton":"EditRecommend_updateButton__58KWV"};